import { useUserInfo } from "@/context/UserInfoContext";
import { useWs } from "@/context/WsContext";
import { isLockAppStatus } from "@/context/WsContext";

export const usePermissions = () => {
  const userInfo = useUserInfo();
  const { wsData } = useWs();
  const isAppLocked = isLockAppStatus(wsData) && wsData.is_lock;
  
  const canView = (resourceKey: string): boolean => {
    if (!userInfo?.permissions) return false;
    
    const permission = userInfo.permissions.find(
      (p) => p.resource_key === resourceKey
    );
    
    return permission?.actions.includes("view") ?? false;
  };

  const canEdit = (resourceKey: string): boolean => {

    if (isAppLocked || userInfo?.is_lock ) return false;

    if (!userInfo?.permissions) return false;

    const permission = userInfo.permissions.find(
      (p) => p.resource_key === resourceKey
    );

    return permission?.actions.includes("edit") ?? false;
  };

  const getAllPermissions = () => {
    return userInfo?.permissions ?? [];
  };

  return {
    canView,
    canEdit,
    getAllPermissions,
    userInfo,
  };
};